import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Undo2, Loader2, Clock } from "lucide-react";
import api from "../../lib/axios";
import { Button } from "@/components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const formatRemaining = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

export const FactoryUndoMergeBanner = ({ lastMerge, factoryPassword, onUndone, onExpired }) => {
  const [remaining, setRemaining] = useState(0);
  const [isUndoing, setIsUndoing] = useState(false);

  useEffect(() => {
    if (!lastMerge) return undefined;
    const tick = () => {
      const ms = new Date(lastMerge.undo_expires_at).getTime() - Date.now();
      setRemaining(ms);
      if (ms <= 0) onExpired?.();
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [lastMerge, onExpired]);

  if (!lastMerge || remaining <= 0) return null;

  const handleUndo = async () => {
    setIsUndoing(true);
    try {
      const res = await api.post(
        `${API}/factory/merge-types/${lastMerge.merge_id}/undo`,
        {},
        { headers: { "X-Factory-Password": factoryPassword } }
      );
      toast.success(`Fusión revertida: ${res.data.restored} tipo${res.data.restored === 1 ? "" : "s"} restaurado${res.data.restored === 1 ? "" : "s"}`);
      onUndone?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || "No se pudo deshacer la fusión");
    } finally {
      setIsUndoing(false);
    }
  };

  return (
    <div
      className="flex items-center justify-between gap-3 px-4 py-3 rounded-lg border border-indigo-200 bg-indigo-50 text-indigo-900"
      data-testid="factory-undo-merge-banner"
    >
      <div className="flex items-center gap-3 text-sm">
        <Undo2 className="w-4 h-4 text-indigo-600 shrink-0" />
        <span>
          Fusionaste <strong>{lastMerge.merged}</strong> tipo{lastMerge.merged === 1 ? "" : "s"} en{" "}
          <strong>"{lastMerge.target_name}"</strong>.
        </span>
        <span className="flex items-center gap-1 text-xs text-indigo-700 font-mono" data-testid="undo-merge-countdown">
          <Clock className="w-3 h-3" /> {formatRemaining(remaining)}
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={handleUndo}
        disabled={isUndoing}
        className="border-indigo-300 text-indigo-700 hover:bg-indigo-100"
        data-testid="undo-merge-btn"
      >
        {isUndoing ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Undo2 className="w-4 h-4 mr-2" />}
        Deshacer fusión
      </Button>
    </div>
  );
};

export default FactoryUndoMergeBanner;
